import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, Input, Popconfirm, message } from 'antd'
import styled from 'styled-components'
import { actions } from '../../redux/modules/templatesActions'
import { actions as itemActions } from '../../redux/modules/jobFunctions/itemActions'
import MaterialRequestItems from '../../components/MaterialRequestItems'
import history from '../../history'
import { arrayMove, convertToReactSelectOption } from '../../util'
import config from '../../config'

const { API_BASE } = config

const Container = styled.div`
  padding: 25px;
`
const MarginTop = styled.div`
  margin-top: 15px;
`
const propTypes = {}
const { TextArea } = Input

class TemplatesMaterialRequest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentKey: 'material_request',
      currentId: +this.props.match.params.templateId,
      requestItems: []
    }
  }

  componentWillMount() {
    this.props.getTemplateById({
      templateType: this.state.currentKey,
      templateId: this.state.currentId
    })
    this.props.getAllItems()
  }

  componentDidUpdate(prevProps) {
    if (this.props.templatesActions && this.props.templatesActions.loadedTemplate) {
      if (
        this.props.templatesActions.loadedTemplate !== prevProps.templatesActions.loadedTemplate
      ) {
        const loadedTemplate = this.props.templatesActions.loadedTemplate.template_info[0]
        const templateItems = this.props.templatesActions.loadedTemplate.template_items
        if (loadedTemplate) {
          this.setState({
            templateName: loadedTemplate.name,
            templateDescription: loadedTemplate.description,
            requestedBy: loadedTemplate.requested_by,
            requestItems: templateItems
          })
        }
      }
    }
  }

  handleInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleCreate = () => {
    const { currentId, templateName, templateDescription, requestedBy, requestItems } = this.state
    const data = {
      requested_by: requestedBy,
      description: templateDescription,
      name: templateName,
      estimate_template_id: currentId,
      items: requestItems
    }
    if (currentId === 0) {
      this.props.createTemplate({
        templateType: 'material_request',
        content: data,
        userId: this.props.authentication.user.userId
      })
    } else {
      this.props.saveTemplate({
        templateId: this.state.currentId,
        templateType: 'material_request',
        content: data,
        userId: this.props.authentication.user.userId
      })
    }

    message.success('Changes saved.')
    this.setState({ contentData: null, currentId: 0, modalVisible: false })
  }

  confirmDelete = () => {
    this.props.deleteTemplate({
      templateId: this.state.currentId,
      templateType: 'material_request'
    })

    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  addItem = () => {
    const itemsArray = this.state.requestItems
    itemsArray.push({
      name: '',
      quantity: 0,
      notes: '',
      quantity_delivered: 0
    })
    this.setState({
      requestItems: itemsArray
    })
  }

  deleteItem = index => {
    const itemsArray = this.state.requestItems
    itemsArray.splice(index, 1)
    this.setState({
      requestItems: itemsArray
    })
  }

  moveUp = index => {
    this.setState({
      requestItems: arrayMove(this.state.requestItems, index, index - 1)
    })
  }

  moveDown = index => {
    this.setState({
      requestItems: arrayMove(this.state.requestItems, index, index + 1)
    })
  }

  onItemChange = (field, value, index) => {
    const itemArray = this.state.requestItems
    console.log(field, value, index)
    itemArray[index][field] = value
    this.setState(
      {
        requestItems: itemArray
      },
      () => {
        console.log(this.state.requestItems)
      }
    )
  }
  render() {
    if (this.props.templatesActions && this.props.templatesActions.loadingTemplate) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <Container>
          <h2>Material Request Template</h2>
          <div className="row">
            <div className="col-md-6">
              <div>Template</div>
              <Input
                value={this.state.templateName}
                onChange={event => this.handleInputChange(event.target.value, 'templateName')}
              />
            </div>
          </div>
          <div>Description</div>
          <TextArea
            placeholder="Type in description..."
            rows={4}
            onChange={event => this.handleInputChange(event.target.value, 'templateDescription')}
            value={this.state.templateDescription}
          />
          <div className="row">
            <div className="col-md-12">
              <MarginTop>
                {this.state.currentId > 0 && (
                  <Fragment>
                    <Popconfirm
                      title="Are you sure you want to delete this record?"
                      onConfirm={this.confirmDelete}
                      onCancel={this.cancelDelete}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="danger" icon="delete" className="mr-2" />
                    </Popconfirm>
                    <a href={`${API_BASE}/api/templates/material_request/id/${1}/print`}>
                      <Button icon="printer" className="mr-2" />
                    </a>
                  </Fragment>
                )}
              </MarginTop>
            </div>
          </div>
          <MaterialRequestItems
            getAllItems={this.props.getAllItems}
            templateManagement={true}
            allItems={
              this.props.itemActions &&
              this.props.itemActions.allItems &&
              this.props.itemActions.allItems.data &&
              convertToReactSelectOption(this.props.itemActions.allItems.data)
            }
            requestItems={this.state.requestItems}
            deleteItem={this.deleteItem}
            moveUp={this.moveUp}
            moveDown={this.moveDown}
            addItem={this.addItem}
            onItemChange={this.onItemChange}
          />
          <MarginTop>
            <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
            <Button type="primary" onClick={() => this.handleCreate()}>
              {this.state.currentId === 0 && <span>Create Template</span>}
              {this.state.currentId > 0 && <span>Save Changes</span>}
            </Button>
          </MarginTop>
        </Container>
      )
    }
  }
}

const mapStateToProps = ({ templatesActions, itemActions, authentication }, ownProps) => ({
  templatesActions,
  itemActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, itemActions), dispatch)
})

TemplatesMaterialRequest.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TemplatesMaterialRequest))



// WEBPACK FOOTER //
// ./src/containers/templates/materialRequestTemplate.js